import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("small", null, "Pool name", -1)
const _hoisted_2 = /*#__PURE__*/_createElementVNode("small", null, "Date range", -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("small", null, "Pool type", -1)
const _hoisted_4 = { key: 0 }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("small", null, "Number of prepopulated VATs per user", -1)
const _hoisted_6 = { key: 1 }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("small", null, "Triggered On Event", -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("small", null, "Triggered Count", -1)
const _hoisted_9 = { key: 2 }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("small", null, "Drop interval", -1)
const _hoisted_11 = /*#__PURE__*/_createElementVNode("small", null, "Interval start time", -1)
const _hoisted_12 = /*#__PURE__*/_createElementVNode("small", null, "Interval end time", -1)
const _hoisted_13 = { key: 4 }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("small", null, "Max Drop radius from user", -1)
const _hoisted_15 = { key: 5 }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("small", null, "Min Drop radius from user", -1)
const _hoisted_17 = { key: 6 }
const _hoisted_18 = { key: 7 }
const _hoisted_19 = { key: 8 }
const _hoisted_20 = /*#__PURE__*/_createElementVNode("small", null, "Maximum user claim interval", -1)
const _hoisted_21 = { key: 9 }
const _hoisted_22 = /*#__PURE__*/_createElementVNode("small", null, "Drop location radius", -1)
const _hoisted_23 = { key: 10 }
const _hoisted_24 = /*#__PURE__*/_createElementVNode("small", null, "Select AI Template", -1)
const _hoisted_25 = /*#__PURE__*/_createElementVNode("div", null, "VAT Categories", -1)
const _hoisted_26 = /*#__PURE__*/_createElementVNode("br", null, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_input = _resolveComponent("a-input")!
  const _component_a_tooltip = _resolveComponent("a-tooltip")!
  const _component_a_range_picker = _resolveComponent("a-range-picker")!
  const _component_a_select_option = _resolveComponent("a-select-option")!
  const _component_a_select = _resolveComponent("a-select")!
  const _component_a_input_number = _resolveComponent("a-input-number")!
  const _component_a_time_picker = _resolveComponent("a-time-picker")!
  const _component_a_col = _resolveComponent("a-col")!
  const _component_a_row = _resolveComponent("a-row")!
  const _component_a_checkbox = _resolveComponent("a-checkbox")!
  const _component_PoolCategorySplit = _resolveComponent("PoolCategorySplit")!
  const _component_a_card = _resolveComponent("a-card")!
  const _component_Scroller = _resolveComponent("Scroller")!

  return (_openBlock(), _createBlock(_component_Scroller, null, {
    default: _withCtx(() => [
      (_ctx.selectedDropPool)
        ? (_openBlock(), _createBlock(_component_a_row, {
            key: 0,
            gutter: 15
          }, {
            default: _withCtx(() => [
              _createVNode(_component_a_col, { span: 12 }, {
                default: _withCtx(() => [
                  _hoisted_1,
                  _createVNode(_component_a_tooltip, {
                    placement: "right",
                    title: "Give the pool a name"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_input, {
                        class: "custom-input-style",
                        placeholder: "Pool name",
                        value: _ctx.selectedDropPool.name,
                        "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.selectedDropPool.name) = $event))
                      }, null, 8, ["value"])
                    ]),
                    _: 1
                  }),
                  _hoisted_2,
                  _createVNode(_component_a_tooltip, {
                    placement: "right",
                    title: "Select a date range, within the campaign dates"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_range_picker, {
                        class: "custom-input-style",
                        allowClear: false,
                        "disabled-date": _ctx.disabledDate,
                        value: [
							_ctx.moment(_ctx.selectedDropPool.startDate),
							_ctx.moment(_ctx.selectedDropPool.endDate)
						],
                        onChange: _ctx.onDateChange
                      }, null, 8, ["disabled-date", "value", "onChange"])
                    ]),
                    _: 1
                  }),
                  _hoisted_3,
                  _createVNode(_component_a_tooltip, {
                    placement: "right",
                    title: "Select proximity drop in order to drop wherever the user is and GPS drop to drop within a radius of a location"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_select, {
                        value: _ctx.selectedDropPool.dropType,
                        "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.selectedDropPool.dropType) = $event)),
                        class: "custom-input-style",
                        style: {"width":"100%"},
                        onChange: _ctx.handleDropTypeChange
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_a_select_option, { value: "pin" }, {
                            default: _withCtx(() => [
                              _createTextVNode(" Proximity drop ")
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_a_select_option, { value: "gps" }, {
                            default: _withCtx(() => [
                              _createTextVNode(" GPS locations drop ")
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_a_select_option, { value: "prepopulatedVat" }, {
                            default: _withCtx(() => [
                              _createTextVNode(" Prepopulated VATs ")
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_a_select_option, { value: "shareReward" }, {
                            default: _withCtx(() => [
                              _createTextVNode(" Share Reward ")
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }, 8, ["value", "onChange"])
                    ]),
                    _: 1
                  }),
                  (_ctx.selectedDropPool.dropType === 'prepopulatedVat')
                    ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                        _hoisted_5,
                        _createVNode(_component_a_tooltip, {
                          placement: "right",
                          title: "The number of prepopulated vats in the user's vault after first login"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_a_input_number, {
                              style: {"width":"100%"},
                              class: "custom-input-style",
                              placeholder: "Number of prepopulated Vats",
                              defaultValue: "0",
                              value: _ctx.selectedDropPool.prepopulatedCount,
                              "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.selectedDropPool.prepopulatedCount) = $event))
                            }, null, 8, ["value"])
                          ]),
                          _: 1
                        })
                      ]))
                    : _createCommentVNode("", true),
                  (_ctx.selectedDropPool.dropType === 'shareReward')
                    ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                        _hoisted_7,
                        _createVNode(_component_a_tooltip, {
                          placement: "right",
                          title: "Defines which at what point in the user's journey does the user event get contributed to the triggered count"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_a_select, {
                              value: _ctx.selectedDropPool.triggeredOn,
                              "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.selectedDropPool.triggeredOn) = $event)),
                              class: "custom-input-style",
                              style: {"width":"100%"},
                              onChange: _ctx.handleTriggeredOnChange
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_a_select_option, { value: "share" }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(" Share ")
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_a_select_option, { value: "collected" }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(" Collected ")
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }, 8, ["value", "onChange"])
                          ]),
                          _: 1
                        }),
                        _hoisted_8,
                        _createVNode(_component_a_tooltip, {
                          placement: "right",
                          title: "The amount of times the triggered on event has to occur before a reward is given"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_a_input_number, {
                              style: {"width":"100%"},
                              class: "custom-input-style",
                              placeholder: "0",
                              defaultValue: "0",
                              value: _ctx.selectedDropPool.triggerCount,
                              "onUpdate:value": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.selectedDropPool.triggerCount) = $event))
                            }, null, 8, ["value"])
                          ]),
                          _: 1
                        })
                      ]))
                    : _createCommentVNode("", true),
                  (_ctx.showField('dropInterval'))
                    ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                        _hoisted_10,
                        _createVNode(_component_a_tooltip, {
                          placement: "right",
                          title: "A single drop happens once at the start of a pool date range. Daily happens every day within a pool date range and within a start and end time."
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_a_select, {
                              value: _ctx.selectedDropPool.dropInterval,
                              "onUpdate:value": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.selectedDropPool.dropInterval) = $event)),
                              class: "custom-input-style",
                              style: {"width":"100%"},
                              onChange: _ctx.handleIntervalChange
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_a_select_option, { value: "single" }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(" Single ")
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_a_select_option, { value: "daily" }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(" Daily ")
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }, 8, ["value", "onChange"])
                          ]),
                          _: 1
                        })
                      ]))
                    : _createCommentVNode("", true),
                  (_ctx.showField('dropInterval'))
                    ? (_openBlock(), _createBlock(_component_a_row, {
                        key: 3,
                        gutter: 10
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_a_col, { span: 12 }, {
                            default: _withCtx(() => [
                              _hoisted_11,
                              _createVNode(_component_a_time_picker, {
                                style: {"width":"100%"},
                                class: "custom-input-style",
                                format: "HH:mm",
                                value: 
								_ctx.moment(
									_ctx.selectedDropPool.dropIntervalStart,
									'HH:mm'
								)
							,
                                placeholder: "Start time",
                                onChange: _cache[6] || (_cache[6] = ($event: any) => (_ctx.timeIntervalChange($event, 'start')))
                              }, null, 8, ["value"])
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_a_col, { span: 12 }, {
                            default: _withCtx(() => [
                              _hoisted_12,
                              _createVNode(_component_a_time_picker, {
                                style: {"width":"100%"},
                                format: "HH:mm",
                                value: 
								_ctx.moment(
									_ctx.selectedDropPool.dropIntervalEnd,
									'HH:mm'
								)
							,
                                placeholder: "End time",
                                onChange: _cache[7] || (_cache[7] = ($event: any) => (_ctx.timeIntervalChange($event, 'end')))
                              }, null, 8, ["value"])
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true),
                  (_ctx.showField('dropUserRadius'))
                    ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                        _hoisted_14,
                        _createVNode(_component_a_tooltip, {
                          placement: "right",
                          title: "The max radius in meters to drop from a user"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_a_input_number, {
                              style: {"width":"100%"},
                              class: "custom-input-style",
                              placeholder: "Max user drop radius",
                              defaultValue: "0",
                              value: _ctx.selectedDropPool.dropUserRadius,
                              "onUpdate:value": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.selectedDropPool.dropUserRadius) = $event))
                            }, null, 8, ["value"])
                          ]),
                          _: 1
                        })
                      ]))
                    : _createCommentVNode("", true),
                  (_ctx.showField('minDistanceFromUser'))
                    ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                        _hoisted_16,
                        _createVNode(_component_a_tooltip, {
                          placement: "right",
                          title: "The min radius in meters to drop from a user"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_a_input_number, {
                              style: {"width":"100%"},
                              class: "custom-input-style",
                              placeholder: "Min user drop radius",
                              defaultValue: "0",
                              value: _ctx.selectedDropPool.minDistanceFromUser,
                              "onUpdate:value": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.selectedDropPool.minDistanceFromUser) = $event))
                            }, null, 8, ["value"])
                          ]),
                          _: 1
                        })
                      ]))
                    : _createCommentVNode("", true),
                  (_ctx.showField('dropSize'))
                    ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                        _createElementVNode("small", null, _toDisplayString(_ctx.checkDropType("dropSize").label), 1),
                        _createVNode(_component_a_tooltip, {
                          placement: "right",
                          title: _ctx.checkDropType('dropSize').toolTip
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_a_input_number, {
                              style: {"width":"100%"},
                              class: "custom-input-style",
                              placeholder: _ctx.checkDropType('dropSize').label,
                              defaultValue: "0",
                              value: _ctx.selectedDropPool.dropSize,
                              "onUpdate:value": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.selectedDropPool.dropSize) = $event))
                            }, null, 8, ["placeholder", "value"])
                          ]),
                          _: 1
                        }, 8, ["title"])
                      ]))
                    : _createCommentVNode("", true),
                  (_ctx.showField('maxClaimSize'))
                    ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                        _createElementVNode("small", null, _toDisplayString(_ctx.checkDropType("maxClaimSize").label), 1),
                        _createVNode(_component_a_tooltip, {
                          placement: "right",
                          title: _ctx.checkDropType('maxClaimSize').toolTip
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_a_input_number, {
                              style: {"width":"100%"},
                              class: "custom-input-style",
                              placeholder: _ctx.checkDropType('maxClaimSize').label,
                              value: _ctx.selectedDropPool.maxClaimSize,
                              "onUpdate:value": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.selectedDropPool.maxClaimSize) = $event))
                            }, null, 8, ["placeholder", "value"])
                          ]),
                          _: 1
                        }, 8, ["title"])
                      ]))
                    : _createCommentVNode("", true),
                  (_ctx.showField('maxClaimInterval'))
                    ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                        _hoisted_20,
                        _createVNode(_component_a_tooltip, {
                          placement: "right",
                          title: "The interval in which the maximum claim size exists"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_a_select, {
                              value: _ctx.selectedDropPool.maxClaimInterval,
                              "onUpdate:value": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.selectedDropPool.maxClaimInterval) = $event)),
                              class: "custom-input-style",
                              defautValue: "day",
                              style: {"width":"100%"},
                              onChange: _ctx.handleMaxClaimIntervalChange
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_a_select_option, { value: "hour" }, {
                                  default: _withCtx(() => [
                                    _createTextVNode("Hour")
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_a_select_option, { value: "day" }, {
                                  default: _withCtx(() => [
                                    _createTextVNode("Day")
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_a_select_option, { value: "campaign" }, {
                                  default: _withCtx(() => [
                                    _createTextVNode("Campaign ")
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }, 8, ["value", "onChange"])
                          ]),
                          _: 1
                        })
                      ]))
                    : _createCommentVNode("", true),
                  (_ctx.selectedDropPool.dropType === 'gps')
                    ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
                        _hoisted_22,
                        _createVNode(_component_a_tooltip, {
                          placement: "right",
                          title: "The radius in meters to drop around a location"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_a_input_number, {
                              style: {"width":"100%"},
                              class: "custom-input-style",
                              placeholder: "dropLocationRadius",
                              defaultValue: "0",
                              value: _ctx.selectedDropPool.dropLocationRadius,
                              "onUpdate:value": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.selectedDropPool.dropLocationRadius) = $event))
                            }, null, 8, ["value"])
                          ]),
                          _: 1
                        })
                      ]))
                    : _createCommentVNode("", true),
                  _createVNode(_component_a_tooltip, {
                    placement: "right",
                    title: "Use Enhanced AI over legacy version"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_checkbox, {
                        checked: _ctx.selectedDropPool.useEnhancedAI,
                        "onUpdate:checked": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.selectedDropPool.useEnhancedAI) = $event))
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(" Use enhanced AI ")
                        ]),
                        _: 1
                      }, 8, ["checked"])
                    ]),
                    _: 1
                  }),
                  (_ctx.selectedDropPool.useEnhancedAI)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
                        _hoisted_24,
                        _createVNode(_component_a_tooltip, {
                          placement: "right",
                          title: "Select the AI template to for this pool"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_a_select, {
                              value: _ctx.selectedDropPool.ARTemplateID,
                              "onUpdate:value": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.selectedDropPool.ARTemplateID) = $event)),
                              class: "custom-input-style",
                              placeholder: "Select a Template",
                              style: {"width":"100%"},
                              onChange: _ctx.handleARTemplateChange
                            }, {
                              default: _withCtx(() => [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.arTemplates, (template) => {
                                  return (_openBlock(), _createBlock(_component_a_select_option, {
                                    key: template.id,
                                    value: template.id
                                  }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(_toDisplayString(template.name), 1)
                                    ]),
                                    _: 2
                                  }, 1032, ["value"]))
                                }), 128))
                              ]),
                              _: 1
                            }, 8, ["value", "onChange"])
                          ]),
                          _: 1
                        })
                      ]))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              }),
              _createVNode(_component_a_col, { span: 12 }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_card, null, {
                    default: _withCtx(() => [
                      _hoisted_25,
                      _hoisted_26,
                      _createVNode(_component_a_tooltip, {
                        placement: "right",
                        title: "Select the types and quantity of each item type you would like to make available during each interval at each location(if GPS)"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_a_select, {
                            class: "custom-input-style",
                            mode: "multiple",
                            value: _ctx.categorySplitRef,
                            placeholder: "Please select",
                            style: {"width":"100%"},
                            onChange: _ctx.handleCategoryChange
                          }, {
                            default: _withCtx(() => [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.categories, (category) => {
                                return (_openBlock(), _createBlock(_component_a_select_option, {
                                  key: category.id,
                                  value: `${category.id}_${category.name}`
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(category.name), 1)
                                  ]),
                                  _: 2
                                }, 1032, ["value"]))
                              }), 128))
                            ]),
                            _: 1
                          }, 8, ["value", "onChange"])
                        ]),
                        _: 1
                      }),
                      (_ctx.selectedDropPool.categorySplit.length > 0)
                        ? (_openBlock(), _createBlock(_component_PoolCategorySplit, {
                            key: 0,
                            categorySplit: _ctx.selectedDropPool.categorySplit,
                            onChanged: _ctx.saveCategorySplit
                          }, null, 8, ["categorySplit", "onChanged"]))
                        : _createCommentVNode("", true)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}